// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcy_a bii_ke","ListItemIcon--empty":"bcy_b bii_fl"};